export const STATS = [
  {
    id: 1,
    title: "HOME.STATISTICS.STATS.1.TITLE",
    description: "HOME.STATISTICS.STATS.1.DESCRIPTION",
  },
  {
    id: 2,
    title: "HOME.STATISTICS.STATS.2.TITLE",
    description: "HOME.STATISTICS.STATS.2.DESCRIPTION",
  },
  {
    id: 3,
    title: "HOME.STATISTICS.STATS.3.TITLE",
    description: "HOME.STATISTICS.STATS.3.DESCRIPTION",
  },
];
